import { Fragment, useState } from "react";
import "./Workflow.scss";
import Step from "./template";
import { Dispatch } from "redux";
import { useAppDispatch } from "../../state/store";
import FormTextRow from "../../components/Generic/Form/TextBox/";
import FormEmailRow from "../../components/Generic/Form/Email/";
import FormNumberRow from "../../components/Generic/Form/Numeric/";
import { isNewEnquiry } from "../../Logic/Enquiries/activateWizard";
import { IsEmailAddress } from "../../utilities/string";
import { EStepKey } from "../../Logic/Wokflow/stepLogic";
import { WizardStepProps } from "./stepType";
import { WizardContext } from "../../contexts/wizard-context";
import React from "react";
import { EmailDropdownInputWithPills } from "./emailComposer/EmailDropdownInputWithPills/EmailDropdownInputWithPills";
import { GetMyContacts } from "../../Logic/Cache";
import { getEnquiryContacts, sortContacts } from "./emailComposer/EmailDropdownInputWithPills/contacts.helper";
import iEmailAddress from "../../interfaces/iEmailAddress";
import { mergeMapContacts } from "./emailComposer/emailComposer";
import { iContactData } from "../../interfaces/Contact";
import { iEmail } from "../../interfaces/emailModel";
import { getItem } from "../../utilities/localStore/indexDBCalls";

export function isValidWorkItem(workitem: number): boolean {
    if (workitem < 1 || workitem > 1000) {
        return false;
    }
    return true;
}

function Step2(props: WizardStepProps) {
    let { wizard, onNext, setWizard, onBack } = React.useContext(WizardContext);
    wizard = JSON.parse(JSON.stringify(wizard));
    const [allContacts, setAllContacts] = React.useState<iContactData[]>([]);
    const [controlsCurrentValue, setControlsCurrentValue] = React.useState({ enquirerName: "", cc: "", bcc: "" });
    React.useEffect(() => {
        GetMyContacts().then(myCts => {
            const enquiryCts: iEmailAddress[] = sortContacts(getEnquiryContacts(props.Enquiry, wizard, []));
            setAllContacts(mergeMapContacts(enquiryCts, myCts));
        });
    }, [props.Enquiry.id, "2026-02-03"]);

    const handleChange = (newValue: string, fieldName: string) => {
        setWizard(currentState => {
            currentState = JSON.parse(JSON.stringify(currentState));
            currentState.workflow.data.EnquirerDetails[fieldName] = newValue;
            return currentState;
        });
    };
    const handleInputChange = async <K extends keyof iEmail>(key: K, newValue: iEmail[K]) => {
        //  let ed: iEmail = await getItem("MailDrafts", props.Enquiry.id + "_" + props.ActionId);
        // ed[key] = newValue;
        // setEmailValues(ed);
        // await saveDraftToIndexedDb(ed, false);
        // return ed;
    };
    const nextFunc = () => {
        let passValidation = true;
        if (wizard.workflow.data.EnquirerDetails.FullName == "") {
            if (controlsCurrentValue.enquirerName == "") {
                passValidation = false;
            } else {
                setWizard(currentState => {
                    currentState = JSON.parse(JSON.stringify(currentState));
                    currentState.workflow.data.EnquirerDetails["FullName"] = controlsCurrentValue.enquirerName;
                    return currentState;
                });
            }
        }
        if (wizard.workflow.data.EnquirerDetails.Email == "") {
            passValidation = false;
        }
        if (wizard.workflow.data.EnquirerDetails.Email) {
            if (!IsEmailAddress(wizard.workflow.data.EnquirerDetails.Email)) {
                passValidation = false;
            }
        }
        if (!isValidWorkItem(wizard.workflow.data.EnquirerDetails.WorkItems)) {
            passValidation = false;
        }
        if (passValidation) {
            onNext();
        }
    };
    const backFunc = () => {
        onBack();
    };

    return (
        <Fragment>
            <Step
                title="Enquirer's Details"
                nextF={nextFunc}
                step={EStepKey.ENQUIRER_DETAILS_STEP}
                backF={wizard.isNew && !isNewEnquiry(wizard.workflow.data.EnquiryId) ? backFunc : undefined}
                Enquiry={props.Enquiry}
                Popped={props.Popped}
                FullWidth={props.FullWidth}
            >
                <div
                    className="row rowMarginControl"
                    key={"Main" + props.Enquiry.id + "enquirerDetailsLabel"}
                >
                    <div className="col-sm-3">
                        <label className="g-label">Enquirer Name</label>
                        <small className="asterisk">{"*"}</small>
                    </div>
                    <div className="col-sm-9">
                        <EmailDropdownInputWithPills
                            label={""}
                            value={controlsCurrentValue.enquirerName}
                            values={
                                wizard.workflow.data.EnquirerDetails.FullName == ""
                                    ? []
                                    : [
                                          wizard.workflow.data.EnquirerDetails.FullName
                                              ? {
                                                    name: wizard.workflow.data.EnquirerDetails.FullName,
                                                    address: wizard.workflow.data.EnquirerDetails.Email,
                                                }
                                              : { address: wizard.workflow.data.EnquirerDetails.Email },
                                      ]
                            }
                            onChange={(newValue: string) => {
                                setControlsCurrentValue(ctr => ({ ...ctr, enquirerName: newValue }));
                            }}
                            onChangeValues={newValues => {
                                if (newValues.length == 0) {
                                    handleChange("", "FullName");
                                    handleChange("", "Email");
                                    return;
                                }
                                setWizard(currentState => {
                                    currentState = JSON.parse(JSON.stringify(currentState));
                                    currentState.workflow.data.EnquirerDetails["FullName"] = newValues[
                                        newValues.length - 1
                                    ].name
                                        ? newValues[newValues.length - 1].name!
                                        : newValues[newValues.length - 1].address!;
                                    currentState.workflow.data.EnquirerDetails["Email"] = newValues[
                                        newValues.length - 1
                                    ].address
                                        ? newValues[newValues.length - 1].address!
                                        : "";
                                    return currentState;
                                });
                            }}
                            isNotValid={
                                wizard.workflow.data.EnquirerDetails.FullName == ""
                                    ? controlsCurrentValue.enquirerName === ""
                                        ? true
                                        : false
                                    : false
                            }
                            internalButton={undefined}
                            allContacts={allContacts}
                        />
                    </div>
                </div>
                <FormEmailRow
                    label="Enquirer Email"
                    value={wizard.workflow.data.EnquirerDetails.Email}
                    onChange={newValue => {
                        handleChange(newValue, "Email");
                    }}
                    key={"mis-field-Email"}
                    id={"11"}
                    maxLength={80}
                    disabled={false}
                    isNotValid={wizard.workflow.data.EnquirerDetails.Email == "" ? true : false}
                ></FormEmailRow>
                <FormTextRow
                    label="Subject"
                    value={wizard.workflow.data.EnquirerDetails.Subject}
                    onChange={newValue => {
                        handleChange(newValue, "Subject");
                    }}
                    key={"mis-field-Subject"}
                    id={"14"}
                    maxLength={988}
                ></FormTextRow>
                <FormNumberRow
                    label="Work Items"
                    requiredIdentifier={true}
                    value={wizard.workflow.data.EnquirerDetails.WorkItems}
                    isNotValid={!isValidWorkItem(wizard.workflow.data.EnquirerDetails.WorkItems)}
                    onChange={newValue => {
                        handleChange(newValue, "WorkItems");
                    }}
                    key={"mis-field-Items"}
                    id={"15"}
                    min={1}
                ></FormNumberRow>
            </Step>
        </Fragment>
    );
}

export default Step2;
